import {
  AUTH_LOGOUT,
  AUTH_MODAL,
  AUTH_CUSTOMER_TOKEN,
  AUTH_GUEST_TOKEN,
  AUTH_CHECK_PHONE,
  AUTH_PROFILE,
  AUTH_PENDING,
  SET_USER_TYPE,
  AUTH_FORGOT_PASSWORD,
  AUTH_GUEST_INFO,
  AUTH_TOKEN,
} from './types';

import {
  lsAuthenticatedUser,
  lsToken,
  lsUserType,
} from './state';
/**
 * Auth Vuex Store Module Mutations
 */
export default {
  /**
   * Logout
   */
  [AUTH_LOGOUT]: (state) => {
    state.token = null;
    state.user = null;
    state.phone = null;
    state.smsVerified = null;

    localStorage.removeItem(lsToken);
    // TODO: you may want to remove it only
    // if user didn't select "keep it for 30 days"
    localStorage.removeItem(lsAuthenticatedUser);
    localStorage.removeItem(lsUserType);
  },

  /**
   * Show login modal
   */
  [AUTH_MODAL]: (state, { name, value }) => {
    state.modals[name] = value;
  },

  /**
   * Store user auth token
   */
  [AUTH_CUSTOMER_TOKEN]: (state, data) => {
    state.token = data;
    state.beforeLoginMessage = null;
    localStorage.setItem(lsToken, data);
    localStorage.setItem(lsUserType, 'customer');
  },

  /**
   * Store guest token
   */
  [AUTH_GUEST_TOKEN]: (state,  data) => {
    state.token = data.token;
    localStorage.setItem(lsToken, data.token);
  },

  /**
   * Store auth token
   */
  [AUTH_TOKEN]: (state,  data) => {
    state.token = data.token;
    localStorage.setItem(lsToken, data.token);
  },

  /**
   * Store phone data and opens login modal.
   */
  [AUTH_CHECK_PHONE]: (state, phone) => {
    state.phone = phone;
  },

  /**
   * Store user profile in store and local storage
   */
  [AUTH_PROFILE]: (state, data) => {
    state.user = data;
    localStorage.setItem(lsAuthenticatedUser, JSON.stringify(data));
  },
  /**
   * Set user type depending on login (guest, customer)
   */
  [SET_USER_TYPE]: (state, type) => {
    state.userType = type;
  },

  /**
   * Set auth pending state.
   * @param {Boolean} value.
   */
  [AUTH_PENDING]: (state, value) => {
    state.pending = value;
  },
  /**
   * Store email for forgot password.
   */
  [AUTH_FORGOT_PASSWORD]: (state, { email, message }) => {
    state.modals.forgotPassword = false;
    state.modals.login = true;
    state.beforeLoginMessage = message;
    state.email = email;
  },

  /**
   * Store guest auth data and guest phone
   */
  [AUTH_GUEST_INFO]: (state,  data) => {
    state.phone = data.phone;
    state.guestAccountData = data;
  },
};



// WEBPACK FOOTER //
// ./src/apps/auth/store/mutations.js